import React from "react";
import "../css/terms.scss";
import { Link } from "react-router-dom";

function Terms() {
  return (
    <div className="three-fourths columns medium-down--one-whole offset-by-two is-hidden-offset-mobile-only">
      <h1>Terms &amp; Conditions</h1>
      <div className="feature-divider" />
      <div className="rte">
        <p>
          These terms govern use of the baplehollow website and purchases made
          through it. The website is operated by Hong Kong Ruijingsheng Trading
          Co., Limited, whose business address is RM 12, UNIT 12A, 13/F, BLOCK
          1, CAMEL PAINT BUILDING, 62 HOI YUEN ROAD, KWUN TONG, HONG KONG.
        </p>
        <ul>
          <li>Product colours can vary slightly between screens. Measurements, materials, included pieces and care information are stated on each product page.</li>
          <li>Prices are shown and processed in USD. A flat $9.99 USD shipping charge is added at checkout unless the page expressly states otherwise.</li>
          <li>An order is not accepted until payment is confirmed. We may cancel and refund an order when stock is unavailable, the address cannot be served, or a transaction fails legal or fraud checks.</li>
          <li>Customers must provide accurate contact and delivery information. Contact us promptly if a correction is needed; changes are not guaranteed after dispatch.</li>
          <li>We do not ship to destinations restricted by applicable sanctions, carriers or payment services. Regional restrictions may also apply within an otherwise available country.</li>
          <li>Our <Link to="/shipping">Shipping Policy</Link>, <Link to="/returns">Returns Policy</Link> and <Link to="/privacy">Privacy Policy</Link> form part of these terms.</li>
          <li>Site copy, original photography, graphics and the baplehollow identity may not be reproduced for commercial use without permission.</li>
          <li>Nothing in these terms limits consumer rights that cannot legally be excluded.</li>
        </ul>
        <p>Questions: <a href="mailto:model@baplehollow.online">model@baplehollow.online</a>.</p>
      </div>
    </div>
  );
}

export default Terms;
